module.exports = __webpack_public_path__ + "static/media/buyer-bg.jpg";